const formatter = new Intl.NumberFormat('de-CH', { style: 'decimal', maximumFractionDigits: 0 });

export const formatNumber = (value: number): string => formatter.format(value);
